<div [@inOut] [ngClass]="{'lv-votum-box': !isScreenSizeMobile,
                   'lv-votum-box-mobile': isScreenSizeMobile}">
  <lv-uiartefakt-container class="lv-votum-box-content"
                           [uiArtefakte]="uiArtefakt.UIArtefakt"></lv-uiartefakt-container>
</div>
